module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-20.3b42e3da.svg";